import React from "react";
import PropTypes from "prop-types";

const Details = ({ name, description, url }) => {
  return (
    <div className="m-rte">
      <h3>{name}</h3>
      {description && (
        <div
          className="a-color-light"
          dangerouslySetInnerHTML={{
            __html: description,
          }}
        ></div>
      )}
      <p>
        <a className="t-link-underlined-padded" href={url}>
          View Details
        </a>
      </p>
    </div>
  );
};

Details.displayName = "PublicationSlider.Details";

Details.propTypes = {
  name: PropTypes.string.isRequired,
  description: PropTypes.string,
  url: PropTypes.string.isRequired,
};

export default Details;
